import React from 'react';
import dynamic from 'next/dynamic';

const Map = dynamic(() => import('../graph/Map'), { ssr: false });
const MapWithoutContainer = dynamic(() => import('../graph/Map').then((c) => c.MapWithoutContainer), { ssr: false });

export const a = 'a';

export function GA102M03({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA102M03"
			height="250px"
			yKey="假日人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['假日人次'] }))}
			link={link}
		/>
	);
}

export function GA301M04({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GA301M04"
			height="400px"
			xKey="館舍名稱"
			yKey="館舍數量"
			searchKeys={['館舍名稱', '地址', '電話']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}

export function GA305M02({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA305M02"
			height="250px"
			yKey="參加學童人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['參加學童人次'] }))}
			link={link}
		/>
	);
}

export function GA311M04({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA311M04"
			height="250px"
			yKey="借閱人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['借閱人次'] }))}
			link={link}
		/>
	);
}

export function GA311M05({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA311M05"
			height="250px"
			yKey="利用人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['利用人次'] }))}
			link={link}
		/>
	);
}

export function GA317M05({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA317M05"
			height="250px"
			yKey="最新一年借閱人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['最新一年借閱人次'] }))}
			link={link}
		/>
	);
}

export function GA317M06({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA317M06"
			height="250px"
			yKey="最新一年利用人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['最新一年利用人次'] }))}
			link={link}
		/>
	);
}

export function GA401M01({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GA401M01"
			height="400px"
			xKey="作品名稱"
			yKey="作品數量"
			searchKeys={['作品名稱', '作品類型', '創作者', '地址']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}

export function GB101M01({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GB101M01"
			height="400px"
			xKey="名稱"
			yKey="作品數量"
			searchKeys={['名稱', '地址', '簡述', '資產類型', '類別', '指定別']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}

export function GB201M01({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GB201M01"
			height="400px"
			yKey="資產數量"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['資產數量'] }))}
			link={link}
		/>
	);
}

export function GB401M03({ data, bigTitle, link }) {
	return (

		<Map
			shortName="GB401M03"
			height="250px"
			bigTitle={bigTitle}
			yKey="參與人次"
			data={data.map((x) => ({ ...x, y: x['參與人次'] }))}
			link={link}
		/>
	);
}

export function GB501B02({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GB501B02"
			height="250px"
			yKey="參與人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['參與人次'] }))}
			link={link}
		/>
	);
}

export function GB501M04({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GB501M04"
			height="250px"
			bigTitle={bigTitle}
			yKey="參與人次"
			data={data.map((x) => ({ ...x, y: x['參與人次'] }))}
			link={link}
		/>
	);
}

export function GC103M03({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GC103M03"
			height="250px"
			yKey="團體個數"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['團體個數'] }))}
			link={link}
		/>
	);
}

export function GC301M01({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GC301M01"
			height="400px"
			xKey="場地名稱"
			yKey="場地數量"
			searchKeys={['場地名稱', '地址']}
			showNameKeys={['申請方式', '場管單位', '聯繫窗口']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}

export function GC302M01({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GC302M01"
			height="400px"
			xKey="場地名稱"
			yKey="場地數量"
			searchKeys={['場地名稱', '地址', '簡述']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}

export function GA317M05H({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GA317M05H"
			height="250px"
			yKey="最新一年借閱人次"
			bigTitle={bigTitle}
			data={data.map((x) => ({ ...x, y: x['最新一年借閱人次'] }))}
			link={link}
		/>
	);
}

export function GB401M03H({ data, bigTitle, link }) {
	return (
		<Map
			shortName="GB401M03H"
			height="250px"
			bigTitle={bigTitle}
			yKey="參與人次"
			data={data.map((x) => ({ ...x, y: x['參與人次'] }))}
			link={link}
		/>
	);
}

export function GB101M01H({
	table, data, bigTitle, link,
}) {
	return (
		<MapWithoutContainer
			shortName="GB101M01H"
			height="400px"
			xKey="名稱"
			yKey="作品數量"
			searchKeys={['名稱', '地址', '簡述', '資產類型', '類別', '指定別']}
			data={data}
			bigTitle={bigTitle}
			table={table}
			link={link}
		/>
	);
}
